import { HttpErrorResponse } from '@angular/common/http';

import type { AnyIntelligenceSettings } from '@core/intelligence-types';
import { createSingleEntityStore, getSingleEntityActions, PickActions } from '@core/ngrx-legacy';

const {
  actions,
  reducer: IntelligenceSettingsReducer,
  selectors: IntelligenceSettingsSelectors,
  namespace: IntelligenceSettingsNamespace,
} = createSingleEntityStore<AnyIntelligenceSettings[]>()('IntelligenceSettingsState', {
  customActions: adapter => {
    const defaultActions = getSingleEntityActions(adapter);
    return {
      toggleFeature: (state, payload: Partial<Record<AnyIntelligenceSettings['field'], boolean>>) =>
        adapter.markAsPending(state),
      toggleFeatureSuccess: (state, payload: AnyIntelligenceSettings[]) =>
        defaultActions.fetchSuccess(state, payload),
      toggleFeatureFailed: (state, payload: HttpErrorResponse) =>
        defaultActions.fetchFailed(state, payload),
    };
  },
});

const IntelligenceSettingsActions: PickActions<typeof actions, 'toggleFeature' | 'fetch'> = actions;

export {
  IntelligenceSettingsActions,
  IntelligenceSettingsReducer,
  IntelligenceSettingsSelectors,
  IntelligenceSettingsNamespace,
};
